/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHexagons = createReactComponent("outline", "hexagons", "IconHexagons", [["path", { "d": "M4 18v-5l4 -2l4 2v5l-4 2z", "key": "svg-0" }], ["path", { "d": "M8 11v-5l4 -2l4 2v5", "key": "svg-1" }], ["path", { "d": "M12 13l4 -2l4 2v5l-4 2l-4 -2", "key": "svg-2" }]]);

export { IconHexagons as default };
//# sourceMappingURL=IconHexagons.mjs.map
